// Mock data for CHIV Properties & Works Ltd.

export const businessInfo = {
  name: "CHIV Properties & Works Ltd.",
  owner: "Er. Gajender Bhati",
  tagline: "Trust Matters",
  phone: "9990459089",
  phoneSecondary: "8851478292",
  email: "chiv5greaternoida@gmail.com",
  address: "Shop No.1, Chuhadpur Market, sector Chi V, Greater Noida, PIN 201310",
  whatsappNumber: "919990459089",
  whatsappMessage: "Hi, I'm interested in your property services. Please share more details.",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.8!2d77.5!3d28.5!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDMwJzAwLjAiTiA3N8KwMzAnMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
};

export const services = [
  {
    id: 1,
    icon: "Building2",
    title: "Property Sale & Purchase",
    description: "Expert guidance for buying or selling residential and commercial properties in Greater Noida with complete legal support."
  },
  {
    id: 2,
    icon: "Key",
    title: "Rental Services",
    description: "Find your perfect rental home or tenant with our trusted network. Quick, hassle-free rental solutions for all budgets."
  },
  {
    id: 3,
    icon: "FileText",
    title: "Rent Agreement & Sale Deed",
    description: "Complete documentation support with rent agreements and sale deeds. Legal, transparent, and hassle-free paperwork."
  },
  {
    id: 4,
    icon: "Paintbrush",
    title: "White Wash & Painting",
    description: "Professional painting services to give your property a fresh, vibrant look. Quality materials and expert craftsmanship."
  },
  {
    id: 5,
    icon: "Hammer",
    title: "Wooden Work",
    description: "Custom wooden furniture, doors, windows, and interior woodwork. Durable designs that enhance your home's beauty."
  },
  {
    id: 6,
    icon: "Wrench",
    title: "Plumbing & Electrical",
    description: "Reliable plumbing and electrical services. Quick repairs, installations, and maintenance by certified professionals."
  },
  {
    id: 7,
    icon: "Home",
    title: "Renovation & Maintenance",
    description: "Complete home renovation solutions from design to execution. Transform your space with our end-to-end services."
  },
  {
    id: 8,
    icon: "ClipboardCheck",
    title: "Property Documentation",
    description: "Expert assistance with property registration, verification, and all legal documentation for peace of mind."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "MapPin",
    title: "Local Market Expertise",
    description: "Deep understanding of Greater Noida real estate market with years of local experience."
  },
  {
    id: 2,
    icon: "Shield",
    title: "Transparent Deals",
    description: "100% transparency in pricing and processes. No hidden charges, only honest service."
  },
  {
    id: 3,
    icon: "FileCheck",
    title: "Complete Documentation Support",
    description: "End-to-end legal and documentation support for all property transactions."
  },
  {
    id: 4,
    icon: "Zap",
    title: "End-to-End Property Solutions",
    description: "From finding properties to maintenance - we handle everything under one roof."
  },
  {
    id: 5,
    icon: "Clock",
    title: "Quick Maintenance Services",
    description: "Rapid response for all renovation and maintenance needs. Quality work, delivered on time."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    location: "Sector Omega, Greater Noida",
    rating: 5,
    text: "CHIV Properties helped me find my dream home in Greater Noida. Er. Gajender sir's guidance was invaluable. Professional, transparent, and trustworthy service.",
    property: "3BHK Apartment Purchase"
  },
  {
    id: 2,
    name: "Priya Sharma",
    location: "Sector Chi V, Greater Noida",
    rating: 5,
    text: "Got complete home renovation done by CHIV. The quality of work exceeded expectations. Highly recommend for any maintenance needs!",
    property: "Home Renovation"
  },
  {
    id: 3,
    name: "Amit Verma",
    location: "Sector Beta II, Greater Noida",
    rating: 5,
    text: "Rented out my property through CHIV Properties. They handled everything from tenant verification to rent agreement. Excellent service and fair pricing.",
    property: "Property Rental"
  },
  {
    id: 4,
    name: "Sunita Gupta",
    location: "Sector Alpha, Greater Noida",
    rating: 5,
    text: "The documentation support was flawless. They made the sale deed process so simple and transparent. Trust matters indeed!",
    property: "Property Sale"
  }
];

export const stats = [
  { label: "Years of Experience", value: "10+" },
  { label: "Properties Closed", value: "500+" },
  { label: "Happy Clients", value: "1000+" },
  { label: "Client Satisfaction", value: "98%" }
];

export const founderInfo = {
  name: "Er. Gajender Bhati",
  title: "Founder & CEO",
  bio: "With over a decade of experience in Greater Noida's real estate market, Er. Gajender Bhati has built CHIV Properties on the foundation of trust and transparency. An engineer by education and a property expert by passion, he believes in a customer-first approach where every client's dream home or investment is treated as his own responsibility. His deep local market knowledge and commitment to honest dealings have made CHIV Properties the trusted name in Greater Noida.",
  image: "https://customer-assets.emergentagent.com/job_af61085c-020d-440f-8d68-89b56fd07925/artifacts/okpfr1oq_image-7.jpg"
};

export const heroImages = {
  main: "https://images.unsplash.com/photo-1758448756880-01dbaf85597d",
  secondary: "https://images.unsplash.com/photo-1762195804027-04a19d9d3ab6"
};

export const serviceImages = {
  renovation1: "https://images.unsplash.com/photo-1646592491560-e121e097dcf2",
  renovation2: "https://images.unsplash.com/photo-1646592491741-e79ae5953486",
  consultation: "https://customer-assets.emergentagent.com/job_af61085c-020d-440f-8d68-89b56fd07925/artifacts/okpfr1oq_image-7.jpg"
};

export const propertySliderImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_af61085c-020d-440f-8d68-89b56fd07925/artifacts/vbkxfmt4_medium%20%281%29.jpeg",
    title: "Premium Residential Complex",
    location: "Sector Chi V, Greater Noida",
    type: "Luxury Apartments"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_af61085c-020d-440f-8d68-89b56fd07925/artifacts/ct2tkj4j_36ca69592e293620ecb273dd43948401.webp",
    title: "Modern Township",
    location: "Sector Chi V, Greater Noida",
    type: "Premium Living"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_af61085c-020d-440f-8d68-89b56fd07925/artifacts/viv49fwt_ent_med.jpg",
    title: "Luxury Residential Society",
    location: "Sector Chi V, Greater Noida",
    type: "High-Rise Complex"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_af61085c-020d-440f-8d68-89b56fd07925/artifacts/8ajous7x_J290227911.main-entrance.15318356l.jpg",
    title: "Elite Housing Complex",
    location: "Sector Chi V, Greater Noida",
    type: "Modern Residences"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_af61085c-020d-440f-8d68-89b56fd07925/artifacts/e9h1deq3_medium.jpeg",
    title: "Premium Society",
    location: "Sector Chi V, Greater Noida",
    type: "Luxury Township"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_af61085c-020d-440f-8d68-89b56fd07925/artifacts/9ilszv30_8a9f8b839335eee70193363c2f640abc_90161_767102_original.jpg",
    title: "Modern Residential Complex",
    location: "Sector Chi V, Greater Noida",
    type: "Premium Apartments"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_af61085c-020d-440f-8d68-89b56fd07925/artifacts/81wefqzh_hqdefault.jpg",
    title: "Luxury Society",
    location: "Sector Chi V, Greater Noida",
    type: "Premium Development"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_af61085c-020d-440f-8d68-89b56fd07925/artifacts/hci8m76k_amrapali-castle-noida-yk89vq72um.jpg",
    title: "High-Rise Complex",
    location: "Sector Chi V, Greater Noida",
    type: "Smart Residences"
  }
];
